const API_BASE = import.meta.env.VITE_API_BASE ?? 'http://localhost:3000';

export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!res.ok) {
    throw new ApiError(res.status, `${res.status} ${res.statusText}`);
  }
  return (await res.json()) as T;
}

export const api = {
  createBook: (body: { storyTemplateId: string }) =>
    request<{ id: string; publicId: string }>('/books', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  updateBook: (id: string, body: Record<string, unknown>) =>
    request<unknown>(`/books/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
    }),
  addPlushie: (bookId: string, body: Record<string, unknown>) =>
    request<unknown>(`/books/${bookId}/plushies`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  uploadAsset: async (bookId: string, file: File, plushieId?: string) => {
    const form = new FormData();
    form.append('file', file);
    const qs = plushieId ? `?plushieId=${encodeURIComponent(plushieId)}` : '';
    const res = await fetch(`${API_BASE}/books/${bookId}/assets${qs}`, {
      method: 'POST',
      body: form,
    });
    if (!res.ok) throw new ApiError(res.status, 'upload failed');
    return res.json();
  },
  getBookByPublicId: (publicId: string) =>
    request<unknown>(`/books/by-public-id/${encodeURIComponent(publicId)}`),
};

export const apiBase = API_BASE;
